import { render } from "./StickyDemo.vue?vue&type=template&id=584f452b&scoped=true"
import script from "./StickyDemo.vue?vue&type=script&lang=ts"
export * from "./StickyDemo.vue?vue&type=script&lang=ts"

import "./StickyDemo.vue?vue&type=style&index=0&id=584f452b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-584f452b"

export default script